import { HELP_FORM_ACK_EMAIL, HELP_FORM_ACK_INTERNAL_MAIL } from 'mk/autogenerated/translations/FaqAskQuestion.sagas.93e09d8ca49a0fbc2846488f39048c2d'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { faq_api_fetch_ask_question_url, faq_api_send_ask_question_url } from 'mk/urls/functions';
import { FAQ_ASK_QUESTION_FORM_NAME } from 'mk2/apps/faq/components/FaqAskQuestionForm';
import { faqIndexUrl } from 'mk2/apps/faq/urls';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRFormError, XHRGetError } from 'mk2/helpers/api';
import { handleXHRFormErrorSaga, handleXHRFormSuccessSaga } from 'mk2/helpers/form';
import { PhotoUploadStatus } from 'mk2/helpers/form.reducers';
import { showSuccessToast } from 'mk2/helpers/toasts';
import { tupdate } from 'mk2/helpers/types';
import { removeEmpty, url } from 'mk2/helpers/urls';
import { getLogger } from 'mk2/logger';
import { getRequestUser } from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';
import { normalize } from 'normalizr';
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import {
    faqAskQuestionFetchApi,
    faqAskQuestionSendApi,
    FaqAskQuestionFetchNormalizedResponse,
    FaqAskQuestionFetchTriggerAction,
    FaqAskQuestionSendNormalizedResponse,
    FaqAskQuestionSendTriggerAction,
    FAQ_ASK_QUESTION_FETCH_TRIGGER,
    FAQ_ASK_QUESTION_SEND_TRIGGER,
} from './FaqAskQuestion.actions';

const logger = getLogger('faq/FaqAskQuestion.sagas');

interface FetchApiResponse {
    body: {
        prefillText: string;
        question: string;
    };
}

function* fetchAskQuestion({ faqId, xhr }: FaqAskQuestionFetchTriggerAction & XHRAction) {
    yield put(faqAskQuestionFetchApi.request(faqId));

    try {
        const response: FetchApiResponse = yield call(
            () => xhr.get(faq_api_fetch_ask_question_url(), removeEmpty({
                faqId,
            })),
        );

        const normalizedResponse: FaqAskQuestionFetchNormalizedResponse = normalize(response.body, {});
        yield put(faqAskQuestionFetchApi.success(faqId, normalizedResponse));

    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(faqAskQuestionFetchApi.failure(faqId, normalizeError(error)));
    }
}

function* sendAskQuestion({ faqId, questionFd, xhr }: FaqAskQuestionSendTriggerAction & XHRAction) {
    yield put(faqAskQuestionSendApi.request(faqId, questionFd));

    // capture client info
    const w = window;
    const d = document;
    const e = d.documentElement;
    const g = d.getElementsByTagName('body')[0];
    const x = w.innerWidth || e.clientWidth || g.clientWidth;
    const y = w.innerHeight || e.clientHeight || g.clientHeight;

    const plugins = [];
    for (let i = 0; i < navigator.plugins.length; i++) {
        plugins.push(navigator.plugins[i].name);
    }

    const clientInfo = {
        screen_res: `${window.screen.width} x ${window.screen.height} @ ${window.screen.colorDepth}bit`,
        browser_res: `${x} x ${y}`,
        user_agent: navigator.userAgent,
        plugins,
    };

    try {
        const response = yield call(
            () => xhr.post(faq_api_send_ask_question_url(), {
                faqId,
                formData: tupdate(questionFd, {
                    clientInfo,
                    photos: questionFd.photos ? questionFd.photos.filter((photo) => photo.status === PhotoUploadStatus.SUCCESS) : [],
                }),
            }),
        );
        const normalizedResponse: FaqAskQuestionSendNormalizedResponse = normalize(response.body, {});

        const gotoUrl = url(faqIndexUrl, { articleSlug: 'faq' });
        yield handleXHRFormSuccessSaga(FAQ_ASK_QUESTION_FORM_NAME, gotoUrl);
        yield put(faqAskQuestionSendApi.success(faqId, questionFd, normalizedResponse));

        const requestUser: UserEntity = yield select(getRequestUser);

        yield showSuccessToast(
            isAuthenticated(requestUser)
                ? HELP_FORM_ACK_INTERNAL_MAIL
                : HELP_FORM_ACK_EMAIL,
        );

    } catch (error) {
        yield handleXHRFormErrorSaga(FAQ_ASK_QUESTION_FORM_NAME, error as XHRFormError, logger);
        yield put(faqAskQuestionSendApi.failure(faqId, questionFd, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(FAQ_ASK_QUESTION_FETCH_TRIGGER, fetchAskQuestion),
        takeEvery(FAQ_ASK_QUESTION_SEND_TRIGGER, sendAskQuestion),
    ]);
}
